"use client";

import React from "react";
import { Map, History, CircleCheck, Globe, GraduationCap, Microscope, Info, Landmark } from "lucide-react";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card";
import { Badge } from "@/components/ui/badge";
const certifications = [{
  id: "ca-teaching",
  name: "CA Teaching Credential",
  description: "Fully certified by the California Commission on Teacher Credentialing, ensuring mastery of state-aligned pedagogical standards and math curricula.",
  icon: Map
}, {
  id: "az-teaching",
  name: "AZ Teaching Certificate",
  description: "Professional educator certification in Arizona, reflecting a deep understanding of diverse learning environments and secondary mathematics instruction.",
  icon: Landmark
}, {
  id: "nbct",
  name: "National Board Certification",
  description: "The highest mark of professional distinction in teaching, awarded for proven impact on student learning and advanced mathematical expertise.",
  icon: CircleCheck
}, {
  id: "uc-berkeley",
  name: "UC Berkeley BA Math",
  description: "A rigorous foundation in pure and applied mathematics from one of the world's top-ranked institutions, providing the depth needed for complex problem solving.",
  icon: Microscope
}, {
  id: "ma-teaching",
  name: "MA in Teaching Math",
  description: "Advanced Master's degree focused on the psychology of learning and effective instructional strategies specifically for mathematical concepts.",
  icon: GraduationCap
}, {
  id: "experience",
  name: "17 Years Experience",
  description: "Nearly two decades of classroom and one-on-one experience helping students bridge gaps in understanding and achieve academic breakthroughs.",
  icon: History
}];
export default function QualityStandards() {
  return <section data-section-id="223150" id="academic-excellence" className="bg-background text-foreground py-24 px-6 md:px-12 lg:px-24 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        
        {}
        <div className="flex flex-col items-center text-center max-w-3xl mx-auto mb-16 space-y-4">
          <Badge variant="outline" className="text-primary border-primary/20 uppercase tracking-widest bg-muted font-default">
            Professional Credentials
          </Badge>
          <h2 className="text-3xl md:text-5xl font-bold font-default tracking-tight text-primary">The Cottone Standard</h2>
          <p className="text-muted-foreground text-lg md:text-xl max-w-2xl font-default">Elite academic qualifications and 17 years of teaching expertise combine to empower your student's mathematical journey.</p>
        </div>

        {}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {certifications.map((cert, i) => {
          const Icon = cert.icon;
          return <div key={cert.id} data-index={i}>
                <HoverCard openDelay={200} closeDelay={100}>
                  <HoverCardTrigger asChild>
                    <div className="group relative flex flex-col items-center justify-center p-10 text-center bg-card border border-border rounded-lg cursor-help transition-all duration-300 hover:border-secondary hover:bg-white hover:shadow-xl hover:shadow-primary/5 h-full">
                      
                      {}
                      <div className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300 text-muted-foreground">
                        <Info className="size-5" />
                      </div>
                      
                      {}
                      <div className="mb-6 p-5 rounded-lg bg-muted text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-colors duration-300 ring-1 ring-border group-hover:ring-primary/50">
                        <Icon className="size-10" strokeWidth={1.5} />
                      </div>
                      
                      {}
                      <h3 className="font-default font-semibold text-xl text-card-foreground">
                        {cert.name}
                      </h3>
                      
                      {}
                      <span className="mt-2 text-xs text-muted-foreground/70 sm:hidden font-default">
                        Tap for details
                      </span>
                    </div>
                  </HoverCardTrigger>
                  
                  <HoverCardContent className="bg-popover text-popover-foreground border-border w-80 shadow-2xl rounded-lg p-5 backdrop-blur-md" sideOffset={12} align="center">
                    <div className="space-y-3">
                      <div className="flex items-center gap-3 border-b border-border/50 pb-3">
                        <div className="p-2 rounded-md bg-accent text-primary">
                          <Icon className="size-5" />
                        </div>
                        <h4 className="font-default font-semibold text-base">
                          {cert.name}
                        </h4>
                      </div>
                      <p className="text-sm text-muted-foreground leading-relaxed font-default">
                        {cert.description}
                      </p>
                    </div>
                  </HoverCardContent>
                </HoverCard>
              </div>;
        })}
        </div>

      </div>
    </section>;
}